<template>
  <h1>Vouchers Management</h1>
  <div id="page-assemble" class="content-section">
    <div class="page-section">
      <h2>Vouchers
        <a @click="addItem()" class="float-right btn btn-primary btn-sm">Add new</a>
      </h2>
      <div class="row">
        <div class="col-md-8">
          <span>Find voucher: </span>
          <input type="text" v-model="searchValue">
          <easy-data-table
              :loading="loading"
              :headers="headers"
              :items="vouchers"
              :search-field="searchField"
              :search-value="searchValue"
              alternating
              border-cell
              buttons-pagination
          >
            <template #empty-message>
              nothing here for the moment
            </template>
            <template #item-datevaliduntil="{ datevaliduntil }">
              <div class="player-wrapper">
                {{formatDateEN(datevaliduntil)}}
              </div>
            </template>

            <template #item-operation="item">
              <div class="operation-wrapper">
                <font-awesome-icon
                    icon="edit"
                    size="1x"
                    class="operation-icon"
                    title="Edit"
                    @click="editItem(item)">
                </font-awesome-icon>
               <!-- <font-awesome-icon
                    icon="trash"
                    size="1x"
                    class="operation-icon delete"
                    title="Delete"
                    @click="deleteItem(item)">
                </font-awesome-icon>-->

              </div>
            </template>
          </easy-data-table>
        </div>
        <div class="edit-item col-md-4" v-if="isEditing || isAdding">
          <FormKit
              v-if="!submitted && !errorMessage"
              type="form"
              v-model="editingItem"
              @submit="saveVouchers"
              :actions="false"
              :config="{
                validationVisibility: 'dirty',
              }"
              form-class="bordered"
              id="formColour"
          >
            <h4 class="text-blue-bold text-left" v-if="isEditing">{{ editingItem.voucher_id }}</h4>

            <h4 class="text-blue-bold text-left" v-if="isAdding">Add new</h4>

            <p>All fields are mandatory</p>

            <div class="formkit-wrapper mb-3"   v-if="isAdding">
              <FormKit
                  v-model="editingItemVoucher_id"
                  name="voucher_id"
                  label="Voucher"
                  label-class="text-left"
                  required
              />

            </div>

            <FormKit
                name="action"
                type="hidden"
                :value="voucherAction"
            />
            <FormKit
                v-model="editingItem.description"
                name="description"
                label="Voucher description"
                label-class="text-left"
                required
            />
            <FormKit
                v-model="editingItem.numleft"
                type="number"
                name="numleft"
                label="Voucher numleft"
                label-class="text-left"
                required
            />
            <FormKit
                v-model="editingItem.voucherrule"
                name="voucherrule"
                type="autocomplete"
                label="Voucher rule"
                label-class="text-left"
                source-label="All voucher rules"
                source-empty-message="No voucher rule found"
                :options="searchVouchersRules"
                searchable
                placeholder="Search voucher rule"
            />
            or
            <FormKit
                v-model="newVoucherrule"
                name="new_voucherrule"
                label="New Voucher rule"
                label-class="text-left"
            />
            <FormKit
                v-model="editingItem.datevaliduntil"
                name="datevaliduntil"
                type="datepicker"
                label="Voucher date valid until"
                label-class="text-left"
                required
                :format="{ date: 'medium' }"
                :sequence="['day']"
                overlay
            />

            <FormKit
                v-if="isEditing"
                name="voucher_id"
                type="hidden"
                value="{{ editingItem.voucher_id }}"
            />


            <FormKit
                type="submit"
                label="Save"
                outer-class="half"
                input-class="$reset btn btn-primary"
            />

            <FormKit
                type="button"
                label="Cancel"
                outer-class="half"
                input-class="$reset btn btn-secondary btn-sm"
                @click="resetVouchers"
            />
          </FormKit>
          <div v-if="submitted">
            <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-success">{{successMessage}}</div>
          </div>
          <div v-if="errorMessage">
            <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-danger">{{errorMessage}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script setup>

import {onMounted, ref} from 'vue'
import 'bootstrap/dist/css/bootstrap.min.css';

import VouchersDataService from "@/services/VouchersDataService";

//const formData = ref({})
const isEditing = ref(false);
const isAdding = ref(false);
const submitted = ref(false);
const errorMessage = ref(false);
const successMessage = ref(false);
const loading = ref(true);
const vouchers =  ref([]);
const editingItem = ref({
  voucherrule: "",
  numleft: "",
  description: "",
  datevaliduntil: "",
  voucher_id: 0,
});
const voucherAction = ref('');
const newVoucherrule = ref('');
const currentVoucher = ref('');
const currentIndex = ref('');
const editingItemVoucher_id = ref('');
const searchField = ref(["voucher_id", "datevaliduntil", "description", "numleft", "voucherrule"]);
const searchValue = ref("");

const headers =[
  { text: "ID", value: "voucher_id", sortable: true  },
  { text: "Valid Until", value: "datevaliduntil", sortable: true  },
  { text: "Description", value: "description", sortable: true },
  { text: "Numleft", value: "numleft", sortable: true },
  { text: "Rule", value: "voucherrule", sortable: true },
  { text: "Actions", value: "operation"},
];
const formatDateEN = (date) => {
  //25/12/2023
  const options = { year: 'numeric', month: 'numeric', day: 'numeric' }
  return new Date(date).toLocaleDateString('en-GB', options)
}
const  createDateAsUTC = (date) => {
  // Eg: from 2020-09-07T21:00:00.000Z TO '2020-09-08'
  var formatDate = new Date(new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()))).toISOString().split('T')[0];
  return formatDate;
}
/**
 * Populate the form details for customer label settings
 */
const editItem = (Item) => {
  isEditing.value = true;
  isAdding.value = false;
  emptyVouchersForm();
  voucherAction.value = 'edit';
  editingItem.value.voucherrule = Item.voucherrule;
  editingItem.value.numleft = Item.numleft;
  editingItem.value.description = Item.description;
  editingItem.value.datevaliduntil = Item.datevaliduntil;
  editingItem.value.voucher_id = Item.voucher_id;
}
const deleteItem = async (Item) => {
  if(confirm("Do you really want to delete?")) {
    VouchersDataService.delete(Item.voucher_id)
        .then(response => {
          if (response.data.status == "OK") {
            isEditing.value = true;
            submitted.value = true;
            successMessage.value = 'Item successful deleted!';
            setTimeout(() => {
              isAdding.value = false;
              isEditing.value = false;
              refreshList();
            }, 3000)

          } else {
            errorMessage.value = response.data.message;
          }
          console.log(response);
        })
        .catch(e => {
          console.log(e);
          errorMessage.value = e;
        });
  }
}
/**
 * Updates a customer colours details
 * @returns {Promise<void>}
 */
const saveVouchers = () => {
  let updateObj;

  if (newVoucherrule.value == "" && editingItem.value.voucherrule == ""){
    errorMessage.value=" Voucher rule is mandatory";
    return false;
  }
  if (editingItem.value.voucher_id == 0)
  {
    editingItem.value.voucher_id = editingItemVoucher_id;
  }
  console.log(editingItem.value.datevaliduntil);
  editingItem.value.datevaliduntil = createDateAsUTC(new Date(editingItem.value.datevaliduntil));
  console.log(editingItem.value.datevaliduntil);
  updateObj = {
    action: voucherAction.value,
    new_voucherrule: newVoucherrule.value,
    voucherrule: editingItem.value.voucherrule,
    numleft: editingItem.value.numleft,
    description: editingItem.value.description,
    datevaliduntil: editingItem.value.datevaliduntil,
    voucher_id: editingItem.value.voucher_id
  }
  let formData = new FormData();
  Object.keys(updateObj).forEach((key) => {
    formData.append(`${key}`, `${updateObj[key]}`);
  });

  VouchersDataService.save(formData)
      .then(response => {
        if (response.data.status == "OK"){
          submitted.value=true;
          successMessage.value = 'Submission successful!';
          setTimeout(() => {
            isAdding.value = false;
            isEditing.value = false;
            refreshList();
          }, 3000)
        } else if (response.data.status == "DUPLICATE") {
          isAdding.value = true;
          submitted.value = false;
          successMessage.value = '';
          errorMessage.value=response.data.message;
        } else {
          errorMessage.value=response.data.status + " Please contact the administrator.";
          setTimeout(() => {
            isAdding.value = false;
            isEditing.value = false;
            errorMessage.value = false;
            resetVouchers();
          }, 3000)
        }
        console.log(response);
      })
      .catch(e => {
        console.log(e);
        errorMessage.value=e;
        setTimeout(() => {
          isAdding.value = false;
          isEditing.value = false;
          errorMessage.value = false;
          resetVouchers();
        }, 3000)
      });
}
/*
const preventSubmit = (e) => {
  e.preventDefault();
  return false;
}*/

/**
 * Perform an API request to find customers based on keyword used on autocomplete
 * @param search
 * @returns {Promise<{label: string, value: *}[]|*[]>}
 */
const searchVouchersRules = async ({search}) => {
  try {
    const response = await VouchersDataService.findVoucherRule(search);
    const res = response.data.data.vouchers;

    // Map the data and return it
    return res.map((entry) => ({
      label: entry.voucherrule,
      value: entry.voucherrule,
    }));
  } catch (e) {
    console.log(e);
    return [];
  }
}
const resetVouchers = () =>  {
  isAdding.value = false;
  isEditing.value = false;
  emptyVouchersForm();
}
const refreshList = async () =>  {
  retrieveVouchers();
  currentVoucher.value = null;
  currentIndex.value = -1;
}
function retrieveVouchers() {
  submitted.value = false;
  errorMessage.value = false;
  VouchersDataService.getAll()
      .then(response => {
        vouchers.value = response.data.data.vouchers;
        loading.value = false;
      })
      .catch(e => {
        console.log(e);
      });
}

function emptyVouchersForm() {
  voucherAction.value = '';
  newVoucherrule.value = '';
  editingItem.value.voucherrule = '';
  editingItem.value.numleft = '';
  editingItem.value.description = '';
  editingItem.value.datevaliduntil = '';
  editingItem.value.voucher_id = '';
  successMessage.value = '';
  errorMessage.value = '';
}
function addItem() {
  isAdding.value = true;
  isEditing.value = false;
  emptyVouchersForm();
  voucherAction.value = 'add';
}
onMounted(() => {
  retrieveVouchers();
})
</script>


<style scoped>

.half {
  float: left;
  width: 50%;
}
.formkit-option {
  display: flex;
  align-items: center;
}
.color-options {
  width: 30px;
  height: 30px;
}
[data-invalid] .formkit-inner {
  border-color: var(--red-color);
  box-shadow: 0 0 0 1px var(--red-color);
}

[data-complete] .formkit-inner {
  border-color: var(--red-color);
  box-shadow: 0 0 0 1px var(--green-color);
}
[data-complete] .formkit-inner::after {
  content: '✅';
  display: block;
  padding: 0.5em;
}
.formkit-form.bordered {
  padding: 0.5rem 1.5rem;
  margin-right: 0;
  margin-left: 0;
  border: 1px solid var(--form-border-color);
  box-shadow: 0 2px 3px var(--form-shadow-color);
  display: block;
  float: left;
  width: 100%;
}
.custom-select-sm {
  height: calc(1.5em + 0.5rem + 2px);
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: .875rem;
}
</style>